import type { RawParams } from "@uirouter/core";

import type { ApiPageType } from "app/pages/sales-intelligence/modules/manage-integrations/types/api-page-type";
import type { RequestAdminFeatureBase } from "app/pages/sales-intelligence/types/requestAdminFeature";
import type { RouterTrackingId } from "single-spa/react-app/router/IRouterState";

import { GATEWAY_TRACKING_NAME } from "../constants/gateway-pages";

export type GatewayTrackingParams = RawParams & {
    featureName?: ApiPageType | RequestAdminFeatureBase;
};

export const createResolveGatewayPageTrackingId =
    (defaultTrackingParams: RouterTrackingId) =>
    (toParams?: GatewayTrackingParams): RouterTrackingId => {
        const featureName = toParams?.featureName;

        return {
            ...defaultTrackingParams,
            subSubSection:
                featureName && featureName in GATEWAY_TRACKING_NAME
                    ? GATEWAY_TRACKING_NAME[featureName]
                    : `${featureName} Gateway page`,
        };
    };
